import ImagePreloader from "../Elements/Preloaders/ImagePreloader";
import {LocationMarkerIcon} from "@heroicons/react/solid";
import Urgent from "../Elements/Badges/Urgent";
import Premium from "../Elements/Badges/Premium";
import HitDetails from "./HitDetails";

const HorizontalHit = ({ hit }) => {
    const {
        option_urgent,
        option_highlighting_active,
        address_postal_code,
        link,
        image_path,
        address_locality,
        type,
        readable_period,
        speciality,
        readable_price,
        partner_name,
        partner_picto,
    } = hit

    return (
        <a href={link} className="flex-grow flex items-stretch p-4 gap-8 bg-white shadow rounded-lg hover:shadow-md transition-shadow group relative" target="_blank">

            <div className="relative justify-stretch flex-shrink-0 w-1/4 max-h-28 shadow rounded-md overflow-hidden bg-gray-50">
                { image_path ? <ImagePreloader src={image_path} className="w-full h-full object-cover"/> : null }
            </div>

            <div className="flex-grow flex flex-col gap-2 text-gray-600">
                <div className="flex flex-wrap justify-between gap-2">
                    <div>
                        <p className="text-indigo-800 group-hover:text-indigo-700 font-bold font-title transition-colors">
                            {speciality}
                        </p>
                        <div className={'flex items-center gap-1 text-sm'}>
                            <LocationMarkerIcon className={'w-4 h-4 group-hover:text-indigo-700'} />
                            <span>{address_locality} {address_postal_code ? '(' + address_postal_code + ')' : null}</span>
                        </div>
                    </div>
                    <div className={'inline-flex gap-2'}>
                        {option_urgent ? <Urgent /> : ''}
                        {option_highlighting_active ? <Premium /> : ''}
                    </div>
                </div>

                <HitDetails {...{ type, readable_period, readable_price }}/>
            </div>
            {
                partner_name ? <div className="absolute top-2 right-2"><img src={partner_picto} alt={partner_name} className="w-12"/></div> : ''
            }

        </a>
    )
}

export default HorizontalHit